import styled from 'styled-components';

export const WebFormContainer = styled.div`
  max-width: 970px;
  margin: 0 auto;
  padding: 12px;
`;

export const Title = styled.h1`
  text-align: center;
  color: #2863d0;
  font-weight: 400;
  text-transform: uppercase;
  
  strong {
    font-weight: 700;
  }
  `;

export const Paragraph = styled.p`
  text-align: center;
  font-size: 18px;
  line-height: 23px;
`;
